package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminUserListItem
import com.merkost.handpass.api.dto.listing.CategoryResponse
import org.w3c.files.File
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class PartnerListingsState(
    val categories: AsyncSection<List<CategoryResponse>> = AsyncSection.Loading,
    val sellerQuery: String = "",
    val sellerResults: List<AdminUserListItem> = emptyList(),
    val sellerSearchLoading: Boolean = false,
    val selectedSeller: AdminUserListItem? = null,
    val uploadedImageUrls: List<String> = emptyList(),
    val isUploadingImage: Boolean = false,
    val isSubmitting: Boolean = false,
) : MVIState

sealed interface PartnerListingsIntent : MVIIntent {
    data object LoadCategories : PartnerListingsIntent
    data class SetSellerQuery(val value: String) : PartnerListingsIntent
    data class SearchSellers(val value: String) : PartnerListingsIntent
    data class SelectSeller(val seller: AdminUserListItem?) : PartnerListingsIntent
    data class UploadImage(val file: File) : PartnerListingsIntent
    data class RemoveImage(val url: String) : PartnerListingsIntent
    data class Submit(
        val title: String,
        val description: String,
        val priceDollars: String,
        val categoryId: String,
        val condition: com.merkost.handpass.api.enums.Condition,
        val city: String,
        val latitude: String,
        val longitude: String,
    ) : PartnerListingsIntent
}

sealed interface PartnerListingsAction : MVIAction {
    data class ShowSuccess(val message: String) : PartnerListingsAction
    data class ShowError(val message: String) : PartnerListingsAction
}
